module.exports = __webpack_public_path__ + "static/media/inspect.d2afd93a.svg";